<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      :width="selected.menu_add === 'folder' ? 600 : 1080"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }} {{ selected.menu_add }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          :class="selected.menu_add === 'folder' ? 'mt-4' : 'mt-2'">
          <ValidationObserver 
            ref="form">
            <div v-if="selected.menu_add === 'folder'">
              <ValidationProvider 
                name="Nama" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Surat Menyurat"
                  hide-details

                  v-model="form.title"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-3"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.title !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>

            <div v-if="selected.menu_add === 'file'">
              <v-row
                align="center"
                class="mb-2">
                <v-col
                  cols="12"
                  md="7">
                  <div>
                    Silahkan pilih template dibawah ini :
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="5">
                  <v-text-field
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    placeholder="Cari . . ."
                    vvvv-uppercase
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search_template"
                    @click:clear="search_template = ''; fetchTemplate();"
                    v-on:keyup.enter="fetchTemplate()"
                    style="border-radius: 10px;">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  v-for="(item, index) in process.template ? 6 : templates"
                  :key="index"
                  cols="12"
                  md="4"
                  class="skeleton_folder">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.template"
                    type="image">
                    <div>
                      <v-card
                        @click="toFiles(item)"

                        flat
                        :color="item.color"
                        style="border-radius: 10px;"
                        
                        :style="selected.template_id === item.id ? `border: 2px solid ${set_color}` : ''">
                        <v-card-text
                          :style="selected.template_id === item.id ? `color: ${set_color}; font-weight: bold;` : 'color: black; font-weight: 500;'">
                          {{ item.title }}
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-skeleton-loader>
                </v-col>
              </v-row>

              <div v-if="!process.template && templates.length < 1">
                <v-card
                  flat
                  style="border: 2px dashed orange; border-radius: 10px;">
                  <v-card-text
                    class="text-center">
                    <div class="body-1 black--text"
                      style="font-weight: 500;">
                      Tidak ada template yang tersedia !!!
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn v-if="selected.menu_add === 'folder'"
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save_folder()"
            @click="save_folder()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; dialog.fullscreen = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.share"
      @keydown.esc="dialog.share = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          Share {{ selected.menu_add }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.share = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider
                name="Pegawai" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pegawai
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-autocomplete
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. John Doe"

                  :search-input.sync="autocomplete.user"
                  :loading="process.user"
                  
                  :items="users"
                  item-value="id"
                  item-text="name"
                  :item-color="set_color"

                  v-model="form.users[0].id"
                  :success="form.users[0].id !== '' && valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pegawai {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.users[0].id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <v-checkbox
                v-model="form.users[0].is_can_download"
                :color="set_color"
                hide-details
                class="mb-6">
                <template v-slot:label>
                  <div
                    class="body-2 black--text"
                    style="opacity: 60%;">
                    Bisa Diunduh ?
                  </div>
                </template>
              </v-checkbox>

              <div>
                <div class="body-2 mb-2">
                  Tanggal Expired
                </div>

                <v-menu
                  ref="expired"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.expired">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Tanggal Expired" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 2023-12-30"
                        hide-details
                        clearable

                        @click:clear="form.users[0].exp_datetime = null;"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.users[0].exp_datetime"
                        :success="form.users[0].exp_datetime !== null && valid"
                        :error-messages="errors"
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Expired {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.users[0].exp_datetime !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.users[0].exp_datetime"
                    @input="picker.expired = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div>
                <div v-if="process.share || (!process.share && shared.length > 0)"
                  class="mt-6 mb-2">
                  Shared
                </div>

                <v-list
                  v-for="(item, index) in process.share ? 3 : shared"
                  :key="index"
                  dense
                  class="py-0"
                  :class="index < shared.length - 1 ? 'mb-4' : ''"
                  style="border: 2px dashed #f0f0f0; border-radius: 10px;">
                  <v-list-item>
                    <v-list-item-avatar
                      size="40">
                      <v-img
                        contain
                        alt="amanata"
                        :src="item.user_image_url !== '' ? item.user_image_url : require('@/assets/image/member_default.jpg')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              size="20"
                              color="white">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2 black--text mb-1"
                        style="font-weight: 500;">
                        {{ item.user_name }}
                      </v-list-item-title>

                      <v-list-item-subtitle
                        class="body-2 font-weight-light">
                        <span v-if="item.exp_datetime !== '' && item.exp_datetime !== null"
                          class="red--text">
                          Expired {{ item.exp_datetime | date }}
                        </span>

                        <span v-else
                          class="orange--text">
                          Expired belum ditentukan
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <div
                      @click="remove_shared(item)"
                      class="cursor-pointer"
                      style="position: absolute; top: -8px; right: -8px;">
                      <v-icon
                        color="red">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </v-list-item>
                </v-list>
              </div>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save_share()"
            @click="save_share()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.share = false; dialog.fullscreen = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center mx-6 my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- FORM TEMPLATE -->
    <v-dialog v-model="dialog.from_template"
      @keydown.esc="dialog.from_template = false; dialog.form = true;"
      :fullscreen="dialog.fullscreen"
      width="1560"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          {{ form.title }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.from_template = false; dialog.fullscreen = false; dialog.form = form.id === '' ? true : false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div v-if="form.template_id == 0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <ValidationProvider 
                      name="Nama File" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama File
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Menyurt"
                        hide-details

                        v-model="form.title"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama File {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.title !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div
                      class="body-2 font-italic mb-2">
                      Silahkan upload data dokumen dengan format PDF:
                    </div>

                    <uploaddocument 
                      v-model="upload.doc">
                      <div slot="activator">
                        <v-btn
                          :disabled="process.doc"
                          :loading="process.doc"
                          block
                          height="40"
                          :color="`${set_color_rgb}`"
                          elevation="0"
                          class="body-2 font-weight-bold text-capitalize d-flex align-center mb-4"
                          :style="`color: ${set_color};`"
                          style="border-radius: 10px;">
                          <v-icon>mdi-file-pdf-box</v-icon>

                          <span
                            class="ml-2">
                            Upload Data PDF
                          </span>
                        </v-btn>
                      </div>
                    </uploaddocument>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                      <div
                        ref="arsippdf">
                        <iframe v-if="form.url !== ''"
                          :src="`${form.url}#toolbar=0`" 
                          allowfullscreen
                          frameborder="0" 
                          width="100%"
                          height="750"
                          style="border-radius: 10px; border: 2px solid #323639;">
                        </iframe>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="form.template_id == 1">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <ValidationProvider 
                      name="Nama File" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama File
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Menyurt"
                        hide-details

                        v-model="form.title"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama File {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.title !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Judul" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Judul
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. SURAT PAKLARING"
                        hide-details

                        v-model="form.template_meta_json_object.judul"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Judul {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.judul !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="No." 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        No.
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 005/PT.UMB/IV/2022"
                        hide-details

                        v-model="form.template_meta_json_object.nomor"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              No. {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Lampiran" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Lampiran
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 1 Lembar"
                        hide-details

                        v-model="form.template_meta_json_object.lampiran"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Lampiran {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="tanggal"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.tanggal">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider 
                            name="Tanggal" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              readonly
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Contoh. 2023-12-30"
                              hide-details
                              clearable

                              @click:clear="form.template_meta_json_object.tanggal = null;"
                              v-on="on"
                              v-bind="attrs"

                              v-model="form.template_meta_json_object.tanggal"
                              :success="form.template_meta_json_object.tanggal !== null && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px; width: 40%;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>

                        <v-date-picker 
                          :color="set_color"
                          v-model="form.template_meta_json_object.tanggal"
                          @input="picker.tanggal = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="Nama Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
                        hide-details

                        v-model="form.template_meta_json_object.nama_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Direktur Utama PT.UMB."
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nama Yang Bersangkutan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Bersangkutan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Wildan Faizal Imawan"
                        hide-details

                        v-model="form.template_meta_json_object.nama_2"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Bersangkutan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_2 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Bersangkutan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Bersangkutan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Programer"
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_2"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Bersangkutan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_2 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Alamat Yang Bersangkutan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Alamat Yang Bersangkutan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-textarea
                        filled
                        rounded
                        dense
                        :color="set_color"

                        rows="3"
                        
                        placeholder="Contoh. Dusun Mlaten RT 003 RW 003 Gadingmangu, Perak, Jombang, Jawa Timur"
                        hide-details

                        v-model="form.template_meta_json_object.alamat_2"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Alamat Yang Bersangkutan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.alamat_2 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>

                    <ValidationProvider
                      name="Unit" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Unit
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-autocomplete
                        filled
                        rounded
                        dense
                        :color="set_color"
                        hide-details
                        placeholder="Contoh. UMB Boga"

                        :loading="process.unit"
                        
                        :items="units"
                        item-value="name"
                        item-text="name"
                        :item-color="set_color"

                        v-model="form.template_meta_json_object.unit"
                        :success="form.template_meta_json_object.unit !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Unit {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.unit !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>

                    <v-row>
                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Masuk
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="tanggal_masuk"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.tanggal_mulai">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Masuk" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 2022-12-30"
                                  hide-details
                                  clearable

                                  @click:clear="form.template_meta_json_object.tanggal_mulai = null; form.template_meta_json_object.tanggal_selesai = null;"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.tanggal_mulai"
                                  :success="form.template_meta_json_object.tanggal_mulai !== null && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Tanggal Masuk {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.tanggal_mulai !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              v-model="form.template_meta_json_object.tanggal_mulai"
                              @input="picker.tanggal_mulai = false; form.template_meta_json_object.tanggal_selesai = null;">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Keluar
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="tanggal_keluar"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.tanggal_selesai">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Keluar" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-30"
                                  hide-details
                                  clearable

                                  @click:clear="form.template_meta_json_object.tanggal_selesai = null;"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.tanggal_selesai"
                                  :success="form.template_meta_json_object.tanggal_selesai !== null && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Tanggal Keluar {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.tanggal_selesai !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              :min="form.template_meta_json_object.tanggal_mulai"
                              v-model="form.template_meta_json_object.tanggal_selesai"
                              @input="picker.tanggal_selesai = false">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>

                    <ValidationProvider 
                      name="Alasan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Alasan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-textarea
                        filled
                        rounded
                        dense
                        :color="set_color"

                        rows="3"
                        
                        placeholder="Contoh. diterima bekerja di perusahaan lain"
                        hide-details

                        v-model="form.template_meta_json_object.alasan"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Alasan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.alasan !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                      <div
                        ref="arsippdf"
                        style="padding: 50px;">
                        <v-card-title
                          class="d-flex justify-center black--text text-uppercase mb-4"
                          style="text-transform: uppercase !important; margin-bottom: 16px !important; display: flex !important; justify-content: center !important; font-size: 1.25rem; font-weight: 500; line-height: 2rem; padding: 16px ">
                          {{ form.template_meta_json_object.judul }}
                        </v-card-title>

                        <v-card-text
                          class="black--text">
                          <v-row>
                            <v-col
                              cols="12"
                              md="7">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  No.
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Hal
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.judul !== '' ? form.template_meta_json_object.judul : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Lampiran
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                                </v-col>
                              </v-row>
                            </v-col>

                            <v-col
                              cols="12"
                              md="5">
                              <div
                                class="text-right"
                                style="text-align: right !important;">
                                Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                              </div>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-6"
                            style="margin-top: 24px !important;">
                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              Yang bertandatangan di bawah ini:
                            </div>

                            <div
                              class="px-8"
                              style="padding-right: 32px !important; padding-left: 32px !important;">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="2"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Nama
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="10"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="2"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Jabatan
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="10"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                                </v-col>
                              </v-row>
                            </div>
                          </div>

                          <div
                            class="mt-2"
                            style="margin-top: 8px !important;">
                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              Dengan ini menerangkan bahwa yang bersangkutan di bawah ini:
                            </div>

                            <div
                              class="px-8"
                              style="padding-right: 32px !important; padding-left: 32px !important;">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="2"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Nama
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="10"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nama_2 !== '' ? form.template_meta_json_object.nama_2 : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="2"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Alamat
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="10"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  <div
                                    class="d-flex align-start"
                                    style="display: flex !important; align-items: flex-start !important;">
                                    <div>
                                      :
                                    </div>

                                    <div
                                      class="ml-1"
                                      style="margin-left: 4px !important;">
                                      {{ form.template_meta_json_object.alamat_2 !== '' ? form.template_meta_json_object.alamat_2 : '__________' }}
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                          </div>

                          <div
                            class="mt-8"
                            style="margin-top: 32px !important;">
                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              Karyawan tersebut benar telah bekerja di {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }} sejak
                              <span v-if="form.template_meta_json_object.tanggal_mulai !== '' && form.template_meta_json_object.tanggal_mulai !== null">
                                {{ form.template_meta_json_object.tanggal_mulai | fulldate }} 
                              </span>

                              <span v-else>
                                __________
                              </span>
                              sampai dengan
                              <span v-if="form.template_meta_json_object.tanggal_selesai !== '' && form.template_meta_json_object.tanggal_selesai !== null">
                                {{ form.template_meta_json_object.tanggal_selesai | fulldate }} 
                              </span>

                              <span v-else>
                                __________
                              </span>
                              Adapun jabatan terakhir saudara adalah sebagai {{ form.template_meta_json_object.jabatan_2 !== '' ? form.template_meta_json_object.jabatan_2 : '__________' }}.
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              Selama bekerja di {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }}, Saudara telah memberikan dedikasi dan loyalitasnya yang besar terhadap perusahaan serta tak pernah sekalipun melakukan hal – hal yang merugikan perusahaan. Dalam hal ini saudara {{ form.template_meta_json_object.nama_2 !== '' ? form.template_meta_json_object.nama_2 : '__________' }} mengundurkan diri karena {{ form.template_meta_json_object.alasan !== '' ? form.template_meta_json_object.alasan : '__________' }}.
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              Kami sangat berterimakasih atas kerja kerasnya selama ini dan mengharapkan saudara dapat sukses pada masa mendatang.
                            </div>

                            <div>
                              Demikian surat paklaring ini kami buat agar dapat dipergunakan dengan semestinya. Atas perhatiannya, kami ucapkan terimakasih.
                            </div>

                            <v-row
                              justify="end"
                              class="mt-8"
                              style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                              <v-col
                                cols="12"
                                md="6"
                                class="text-center"
                                style="text-align: center !important;">
                                <div>
                                  Hormat Kami,
                                </div>

                                <div
                                  class="mb-16"
                                  style="margin-bottom: 64px !important;">
                                  {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                                </div>

                                <div>
                                  {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="form.template_id == 4">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <ValidationProvider 
                      name="Nama File" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama File
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Menyurt"
                        hide-details

                        v-model="form.title"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama File {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.title !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nomor" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nomor
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 005/PT.UMB/IV/2022"
                        hide-details

                        v-model="form.template_meta_json_object.nomor"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nomor {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Lampiran" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Lampiran
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 1 Lembar"
                        hide-details

                        v-model="form.template_meta_json_object.lampiran"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Lampiran {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Hal" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Hal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Pemberitahuan"
                        hide-details

                        v-model="form.template_meta_json_object.hal"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Hal {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.hal !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nama Yang Diundang" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Diundang
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Wildan Faizal Imawan"
                        hide-details

                        v-model="form.template_meta_json_object.nama_2"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Diundang {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_2 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Diundang" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Diundang
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Programer"
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_2"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Diundang {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_2 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Tujuan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tujuan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-textarea
                        filled
                        rounded
                        dense
                        :color="set_color"

                        rows="3"
                        
                        placeholder="Contoh. untuk menyetujui atau tanda tangan dalam hal pencairan keuangan"
                        hide-details

                        v-model="form.template_meta_json_object.tujuan"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tujuan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.tujuan !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="tanggal"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.tanggal">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider 
                            name="Tanggal" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              readonly
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Contoh. 2023-12-30"
                              hide-details
                              clearable

                              @click:clear="form.template_meta_json_object.tanggal = null;"
                              v-on="on"
                              v-bind="attrs"

                              v-model="form.template_meta_json_object.tanggal"
                              :success="form.template_meta_json_object.tanggal !== null && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px; width: 40%;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>

                        <v-date-picker 
                          :color="set_color"
                          v-model="form.template_meta_json_object.tanggal"
                          @input="picker.tanggal = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="Nama Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
                        hide-details

                        v-model="form.template_meta_json_object.nama_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Direktur Utama PT.UMB."
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                      <div
                        ref="arsippdf"
                        style="padding: 50px;">
                        <v-card-text
                          class="black--text py-2">
                          <v-row>
                            <v-col
                              cols="12"
                              md="7">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Nomor
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Lampiran
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Hal
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : <span style="font-weight: 500;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-6"
                            style="margin-top: 24px !important;">
                            <div
                              style="margin-bottom: 1px;">
                              Kepada Yth.
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              {{ form.template_meta_json_object.nama_2 !== '' ? form.template_meta_json_object.nama_2 : '__________' }}
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              {{ form.template_meta_json_object.jabatan_2 !== '' ? form.template_meta_json_object.jabatan_2 : '__________' }}
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              di tempat.
                            </div>
                          </div>

                          <div
                            class="mt-10"
                            style="margin-top: 40px !important;">
                            <v-img
                              contain
                              width="175"
                              height="auto"
                              alt="umb" 
                              :src="require('@/assets/image/assalam.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div
                              class="my-4"
                              style="margin-top: 16px !important; margin-bottom: 16px !important;">
                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Puji Syukur kehadirat Allah SWT yang telah melimpahkan berkah rahmat-Nya dan kesehatan kepada kita semua sehingga kita masih diberikan kesempatan melakukan aktivitas sehari-hari. Sholawat serta salam tidak lupa selalu kita haturkan pada junjungan kita Nabi Muhammad SAW, para sahabat dan para pengikut-Nya sebagai tauladan sampai akhir zaman. Aamiin. 
                              </div>

                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Dengan surat ini, kami (PT.  Umat Mandiri Berkemajuan) bermaksud memberitahukan bahwasannya saat ini saudara {{ form.template_meta_json_object.nama_2 !== '' ? form.template_meta_json_object.nama_2 : '__________' }} masih menjadi {{ form.template_meta_json_object.jabatan_2 !== '' ? form.template_meta_json_object.jabatan_2 : '__________' }}, maka dari itu masih berkewenangan {{ form.template_meta_json_object.tujuan !== '' ? form.template_meta_json_object.tujuan : '__________' }} PT. Umat Mandiri Berkemajuan.
                              </div>

                              <div
                                style="text-indent: 30px;">
                                Demikian surat ini kami sampaikan, atas perhatian dan kerjasamanya kami ucapkan terima kasih.
                              </div>
                            </div>

                            <v-img
                              contain
                              width="175"
                              height="auto"
                              alt="umb" 
                              :src="require('@/assets/image/wassalam.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>

                          <v-row
                            justify="end"
                            class="mt-8"
                            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                            <v-col
                              cols="12"
                              md="6"
                              class="text-center"
                              style="text-align: center !important;">
                              <div>
                                Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                              </div>

                              <div
                                class="mb-16"
                                style="margin-bottom: 64px !important;">
                                {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                              </div>

                              <div>
                                {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="form.template_id == 5">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <ValidationProvider 
                      name="Nama File" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama File
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Menyurt"
                        hide-details

                        v-model="form.title"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama File {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.title !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nomor" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nomor
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 005/PT.UMB/IV/2022"
                        hide-details

                        v-model="form.template_meta_json_object.nomor"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nomor {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Lampiran" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Lampiran
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 1 Lembar"
                        hide-details

                        v-model="form.template_meta_json_object.lampiran"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Lampiran {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Hal" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Hal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Pemberitahuan"
                        hide-details

                        v-model="form.template_meta_json_object.hal"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Hal {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.hal !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <v-btn
                      @click="add_pegawai()"

                      color="#444444"
                      elevation="0"
                      class="text-capitalize white--text mb-4"
                      style="border-radius: 10px;">
                      Tambah Pegawai Yang Diundang
                    </v-btn>

                    <div
                      v-for="(item, index) in form.template_meta_json_object.kepada"
                      :key="index">
                      <v-card
                        flat
                        class="pa-3 mb-6"
                        style="border: 2px dashed #f0f0f0; border-radius: 10px;">
                        <v-btn
                          @click="form.template_meta_json_object.kepada.splice(index, 1)"

                          icon
                          style="position: absolute; top: -15px; right: -15px;">
                          <v-icon
                            color="red">
                            mdi-close-circle
                          </v-icon>
                        </v-btn>

                        <ValidationProvider 
                          :name="`Nama Yang Diundang ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Nama Yang Diundang {{ index + 1 }}
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            filled
                            rounded
                            dense
                            :color="set_color"
                            
                            placeholder="Contoh. Wildan Faizal Imawan"
                            hide-details

                            v-model="item.nama"
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Nama Yang Diundang {{ index + 1 }} {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="item.nama !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          :name="`Jabatan Yang Diundang ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Jabatan Yang Diundang {{ index + 1 }}
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            filled
                            rounded
                            dense
                            :color="set_color"
                            
                            placeholder="Contoh. Direktur Utama"
                            hide-details

                            v-model="item.unit"
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-3"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jabatan Yang Diundang {{ index + 1 }} {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="item.unit !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-card>
                    </div>

                    <ValidationProvider 
                      name="Hari Libur" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Hari Libur
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Hari Raya Idul Fitri Tahun 2023 M\/1444H"
                        hide-details

                        v-model="form.template_meta_json_object.hari_libur"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Hari Libur {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.hari_libur !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <v-row>
                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Mulai
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="tanggal_mulai"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.tanggal_mulai">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Mulai" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-25"
                                  hide-details
                                  clearable

                                  @click:clear="form.template_meta_json_object.tanggal_mulai = null; form.template_meta_json_object.tanggal_selesai = null;"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.tanggal_mulai"
                                  :success="form.template_meta_json_object.tanggal_mulai !== null && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Tanggal Mulai {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.tanggal_mulai !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              v-model="form.template_meta_json_object.tanggal_mulai"
                              @input="picker.tanggal_mulai = false; form.template_meta_json_object.tanggal_selesai = null;">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Selesai
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="tanggal_selesai"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.tanggal_selesai">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Selesai" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-30"
                                  hide-details
                                  clearable

                                  @click:clear="form.template_meta_json_object.tanggal_selesai = null;"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.tanggal_selesai"
                                  :success="form.template_meta_json_object.tanggal_selesai !== null && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Tanggal Selesai {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.tanggal_selesai !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              :min="form.template_meta_json_object.tanggal_mulai"
                              v-model="form.template_meta_json_object.tanggal_selesai"
                              @input="picker.tanggal_selesai = false">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Masuk
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="tanggal_masuk"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.tanggal_masuk">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider 
                            name="Tanggal Masuk" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              readonly
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Contoh. 2023-12-30"
                              hide-details
                              clearable

                              @click:clear="form.template_meta_json_object.tanggal_masuk = null;"
                              v-on="on"
                              v-bind="attrs"

                              v-model="form.template_meta_json_object.tanggal_masuk"
                              :success="form.template_meta_json_object.tanggal_masuk !== null && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px; width: 40%;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal Masuk {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.template_meta_json_object.tanggal_masuk !== null && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>

                        <v-date-picker 
                          :color="set_color"
                          v-model="form.template_meta_json_object.tanggal_masuk"
                          @input="picker.tanggal_masuk = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="Informasi Lain" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Informasi Lain
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-textarea
                        filled
                        rounded
                        dense
                        :color="set_color"

                        rows="3"
                        
                        placeholder="Contoh. perihal dengan Syawalan Keluarga Besar PT. Umat Mandiri Berkemajuan akan diinformasikan kembali (menyusul melalui surat resmi)"
                        hide-details

                        v-model="form.template_meta_json_object.informasi_lain"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Informasi Lain {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.informasi_lain !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="tanggal"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.tanggal">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider 
                            name="Tanggal" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              readonly
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Contoh. 2023-12-30"
                              hide-details
                              clearable

                              @click:clear="form.template_meta_json_object.tanggal = null;"
                              v-on="on"
                              v-bind="attrs"

                              v-model="form.template_meta_json_object.tanggal"
                              :success="form.template_meta_json_object.tanggal !== null && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px; width: 40%;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>

                        <v-date-picker 
                          :color="set_color"
                          v-model="form.template_meta_json_object.tanggal"
                          @input="picker.tanggal = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="Nama Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
                        hide-details

                        v-model="form.template_meta_json_object.nama_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Direktur Utama PT.UMB."
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                      <div
                        ref="arsippdf"
                        style="padding: 50px;">
                        <v-card-text
                          class="black--text py-2">
                          <v-row>
                            <v-col
                              cols="12"
                              md="7">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Nomor
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Lampiran
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Hal
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : <span style="font-weight: 500;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-6"
                            style="margin-top: 24px !important;">
                            <div
                              style="margin-bottom: 1px;">
                              Kepada Yth.
                            </div>

                            <div
                              v-for="(item, index) in form.template_meta_json_object.kepada"
                              :key="index"
                              class="d-flex align-center"
                              style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                              <span>
                                {{ index + 1 }}.
                              </span>

                              <span
                                class="mx-2"
                                style="margin-right: 8px !important; margin-left: 8px !important;">
                                {{ item.nama !== '' ? item.nama : '__________' }}
                              </span>

                              <span>
                                ({{ item.unit !== '' ? item.unit : '__________' }})
                              </span>
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              di lingkungan PT. Umat Mandiri Berkemajuan
                            </div>
                          </div>

                          <div
                            class="mt-10"
                            style="margin-top: 40px !important;">
                            <v-img
                              contain
                              width="175"
                              height="auto"
                              alt="umb" 
                              :src="require('@/assets/image/assalam.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div
                              class="my-4"
                              style="margin-top: 16px !important; margin-bottom: 16px !important;">
                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Dengan hormat, sehubungan dengan memasukinya {{ form.template_meta_json_object.hari_libur !== '' ? form.template_meta_json_object.hari_libur : '__________' }}, maka bersama surat ini kami sampaikan informasi sebagai berikut :
                              </div>

                              <div
                                class="mb-4"
                                style="margin-left: 22px; margin-bottom: 16px !important;">
                                <ol
                                  type="a">
                                  <li
                                    class="pl-2"
                                    style="padding-left: 8px !important;">
                                    Libur menjelang {{ form.template_meta_json_object.hari_libur !== '' ? form.template_meta_json_object.hari_libur : '__________' }} dimulai pada tanggal
                                    <span v-if="form.template_meta_json_object.tanggal_mulai !== '' && form.template_meta_json_object.tanggal_mulai !== null">
                                      {{ form.template_meta_json_object.tanggal_mulai | day }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>

                                    -

                                    <span v-if="form.template_meta_json_object.tanggal_selesai !== '' && form.template_meta_json_object.tanggal_selesai !== null">
                                      {{ form.template_meta_json_object.tanggal_selesai | fulldate }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>
                                  </li>

                                  <li
                                    class="pl-2"
                                    style="padding-left: 8px !important;">
                                    Kegiatan dan aktifitas di lingkungan PT. UMB mulai aktif kembali pada tanggal
                                    <span v-if="form.template_meta_json_object.tanggal_masuk !== '' && form.template_meta_json_object.tanggal_masuk !== null">
                                      {{ form.template_meta_json_object.tanggal_masuk | fulldate }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>
                                  </li>

                                  <li
                                    class="pl-2"
                                    style="padding-left: 8px !important;">
                                    Informasi atau kebijakan lain {{ form.template_meta_json_object.informasi_lain !== '' ? form.template_meta_json_object.informasi_lain : '__________' }}.
                                  </li>
                                </ol>
                              </div>

                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Selanjutnya, mohon bagi pimpinan unit bisnis PT. UMB untuk menyampaikan infromasi tersebut di unit bisnis masing-masing.
                              </div>

                              <div
                                style="text-indent: 30px;">
                                Demikian pemberitahuan ini kami sampaikan atas perhatian dan kerjasamanya diucapkan terima kasih.
                              </div>
                            </div>

                            <v-img
                              contain
                              width="175"
                              height="auto"
                              alt="umb" 
                              :src="require('@/assets/image/wassalam.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>

                          <v-row
                            justify="end"
                            class="mt-8"
                            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                            <v-col
                              cols="12"
                              md="6"
                              class="text-center"
                              style="text-align: center !important;">
                              <div>
                                Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                              </div>

                              <div
                                class="mb-16"
                                style="margin-bottom: 64px !important;">
                                {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                              </div>

                              <div>
                                {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="form.template_id == 3">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <ValidationProvider 
                      name="Nama File" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama File
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Menyurt"
                        hide-details

                        v-model="form.title"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama File {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.title !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nomor" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nomor
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 005/PT.UMB/IV/2022"
                        hide-details

                        v-model="form.template_meta_json_object.nomor"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nomor {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Lampiran" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Lampiran
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 1 Lembar"
                        hide-details

                        v-model="form.template_meta_json_object.lampiran"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Lampiran {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Hal" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Hal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Undangan Rapat Bendahara Unit Bisnis PT. UMB"
                        hide-details

                        v-model="form.template_meta_json_object.hal"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Hal {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.hal !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <v-btn
                      @click="add_pegawai()"

                      color="#444444"
                      elevation="0"
                      class="text-capitalize white--text mb-4"
                      style="border-radius: 10px;">
                      Tambah Pegawai Yang Diundang
                    </v-btn>

                    <div
                      v-for="(item, index) in form.template_meta_json_object.kepada"
                      :key="index">
                      <v-card
                        flat
                        class="pa-3 mb-6"
                        style="border: 2px dashed #f0f0f0; border-radius: 10px;">
                        <v-btn
                          @click="form.template_meta_json_object.kepada.splice(index, 1)"

                          icon
                          style="position: absolute; top: -15px; right: -15px;">
                          <v-icon
                            color="red">
                            mdi-close-circle
                          </v-icon>
                        </v-btn>

                        <ValidationProvider 
                          :name="`Nama Yang Diundang ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Nama Yang Diundang {{ index + 1 }}
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            filled
                            rounded
                            dense
                            :color="set_color"
                            
                            placeholder="Contoh. Wildan Faizal Imawan"
                            hide-details

                            v-model="item.nama"
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Nama Yang Diundang {{ index + 1 }} {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="item.nama !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          :name="`Jabatan Yang Diundang ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Jabatan Yang Diundang {{ index + 1 }}
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            filled
                            rounded
                            dense
                            :color="set_color"
                            
                            placeholder="Contoh. Direktur Utama"
                            hide-details

                            v-model="item.unit"
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-3"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jabatan Yang Diundang {{ index + 1 }} {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="item.unit !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-card>
                    </div>

                    <v-row>
                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Hari/Tanggal
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="hari_tanggal"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.tanggal_mulai">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Hari/Tanggal" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-25"
                                  hide-details
                                  clearable

                                  @click:clear="form.template_meta_json_object.hari_tanggal = null;"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.hari_tanggal"
                                  :success="form.template_meta_json_object.hari_tanggal !== null && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Hari/Tanggal {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.hari_tanggal !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              v-model="form.template_meta_json_object.hari_tanggal"
                              @input="picker.tanggal_mulai = false">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Pukul
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="pukul"
                            v-model="time.pukul"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.template_meta_json_object.pukul"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Pukul" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 09:00"
                                  hide-details

                                  clearable
                                  @click:clear="form.template_meta_json_object.pukul = null"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.pukul"
                                  :success="valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Pukul {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.pukul !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-time-picker
                              v-if="time.pukul"
                              v-model="form.template_meta_json_object.pukul"
                              full-width
                              :color="set_color"
                              format="24hr"
                              @click:minute="$refs.pukul.save(`${form.template_meta_json_object.pukul}`);">
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>

                    <ValidationProvider 
                      name="Tempat" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tempat
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Gedung Sportorium UMY, Lantai Dasar"
                        hide-details

                        v-model="form.template_meta_json_object.tempat"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tempat {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.tempat !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div
                      class="mb-6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Agenda
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <quill-editor 
                        ref="myTextEditor"
                        :options="{
                          placeholder: 'Tuliskan Agenda disini . . .'
                        }"
                        v-model="form.template_meta_json_object.agenda">
                      </quill-editor>
                    </div>

                    <div
                      class="mb-6">
                      <div class="body-2 mb-2">
                        Catatan
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>
                      
                      <quill-editor 
                        ref="myTextEditor"
                        :options="{
                          placeholder: 'Tuliskan Catatan disini . . .'
                        }"
                        v-model="form.template_meta_json_object.catatan">
                      </quill-editor>
                    </div>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="tanggal"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.tanggal">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider 
                            name="Tanggal" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              readonly
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Contoh. 2023-12-30"
                              hide-details
                              clearable

                              @click:clear="form.template_meta_json_object.tanggal = null;"
                              v-on="on"
                              v-bind="attrs"

                              v-model="form.template_meta_json_object.tanggal"
                              :success="form.template_meta_json_object.tanggal !== null && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px; width: 40%;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>

                        <v-date-picker 
                          :color="set_color"
                          v-model="form.template_meta_json_object.tanggal"
                          @input="picker.tanggal = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="Nama Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
                        hide-details

                        v-model="form.template_meta_json_object.nama_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Direktur Utama PT.UMB."
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                      <div
                        ref="arsippdf"
                        style="padding: 50px;">
                        <v-card-text
                          class="black--text py-2">
                          <v-row>
                            <v-col
                              cols="12"
                              md="7">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Nomor
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Lampiran
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Hal
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0 d-flex align-start"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: flex-start !important;">
                                  : <span class="ml-1" style="font-weight: 500; margin-left: 4px !important;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-6"
                            style="margin-top: 24px !important;">
                            <div
                              style="margin-bottom: 1px;">
                              Kepada Yth.
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              Bapak/Ibu/Saudara/i
                            </div>

                            <div
                              v-for="(item, index) in form.template_meta_json_object.kepada"
                              :key="index"
                              class="d-flex align-center"
                              style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                              <span>
                                {{ index + 1 }}.
                              </span>

                              <span
                                class="mx-2"
                                style="margin-right: 8px !important; margin-left: 8px !important;">
                                {{ item.nama !== '' ? item.nama : '__________' }}
                              </span>

                              <span>
                                ({{ item.unit !== '' ? item.unit : '__________' }})
                              </span>
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              di lingkungan PT. Umat Mandiri Berkemajuan
                            </div>
                          </div>

                          <div
                            class="mt-10"
                            style="margin-top: 40px !important;">
                            <div
                              class="font-italic"
                              style="font-weight: 500; font-style: italic !important;">
                              Assalamu’alaikum wr.wb.
                            </div>

                            <div
                              class="my-4"
                              style="margin-top: 16px !important; margin-bottom: 16px !important;">
                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Puji syukur kita panjatkan kepada Allah SWT yang telah memberikan berkah rahmat-Nya dan kesehatan kepada kita semua sehingga kita masih dapat melakukan aktivitas kita sehari-hari. Sholawat dan salam tidak lupa selalu kita haturkan kepada junjungan kita Nabi Muhammad SAW, para sahabat dan para pengikut-Nya sebagai tauladan sampai akhir zaman. Aamin.
                              </div>

                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Sehubungan dengan penyempurnaan sistem SDM di PT. UMB, maka bersama surat ini kami bermaksud mengundang Bapak/Ibu pada :
                              </div>

                              <div
                                class="mb-4"
                                style="margin-bottom: 16px !important;">
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Hari/Tanggal
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    : 
                                    <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                                      {{ form.template_meta_json_object.hari_tanggal | weekday }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>
                                    
                                    ,

                                    <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                                      {{ form.template_meta_json_object.hari_tanggal | fulldate }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Pukul
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    : {{ form.template_meta_json_object.pukul !== '' ? form.template_meta_json_object.pukul : '__________' }} s/d Selesai
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Tempat
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0 d-flex align-start"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: start !important;">
                                    : 
                                    <span
                                      class="ml-1"
                                      style="margin-left: 4px !important;">
                                      {{ form.template_meta_json_object.tempat !== '' ? form.template_meta_json_object.tempat : '__________' }}
                                    </span>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Agenda
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0 d-flex align-start"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: start !important;">
                                    : 
                                    <span v-if="form.template_meta_json_object.agenda !== ''"
                                      class="ml-1 from_html"
                                      style="margin-left: 4px !important;"
                                      v-html="form.template_meta_json_object.agenda">
                                    </span>

                                    <span v-else
                                      class="ml-1"
                                      style="margin-left: 4px !important;">
                                      __________
                                    </span>
                                  </v-col>
                                </v-row>

                                <v-row
                                  class="mt-4">
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="font-weight: 500; padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Catatan
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0 d-flex align-start"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: start !important;">
                                    : 
                                    <span v-if="form.template_meta_json_object.catatan !== ''"
                                      class="ml-1 from_html"
                                      style="margin-left: 4px !important;"
                                      v-html="form.template_meta_json_object.catatan">
                                    </span>

                                    <span v-else
                                      class="ml-1"
                                      style="margin-left: 4px !important;">
                                      __________
                                    </span>
                                  </v-col>
                                </v-row>
                              </div>

                              <div
                                style="text-indent: 30px;">
                                Demikian surat undangan ini kami sampaikan, atas perhatian dan kerjasamanya diucapkan terima kasih.
                              </div>
                            </div>

                            <div
                              class="font-italic"
                              style="font-weight: 500; font-style: italic !important;">
                              Wassalamu’alaikum wr.wb.
                            </div>
                          </div>

                          <v-row
                            justify="end"
                            class="mt-8"
                            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                            <v-col
                              cols="12"
                              md="6"
                              class="text-center"
                              style="text-align: center !important;">
                              <div>
                                Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                              </div>

                              <div
                                class="mb-16"
                                style="margin-bottom: 64px !important;">
                                {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                              </div>

                              <div>
                                {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="form.template_id == 2">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <ValidationProvider 
                      name="Nama File" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama File
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Surat Menyurt"
                        hide-details

                        v-model="form.title"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama File {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.title !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nomor" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nomor
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 005/PT.UMB/IV/2022"
                        hide-details

                        v-model="form.template_meta_json_object.nomor"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nomor {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Lampiran" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Lampiran
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. 1 Lembar"
                        hide-details

                        v-model="form.template_meta_json_object.lampiran"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Lampiran {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Hal" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Hal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Undangan Pengajian dan Buka Bersama Keluarga Besar PT. UMB"
                        hide-details

                        v-model="form.template_meta_json_object.hal"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px; width: 70%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Hal {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.hal !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="tanggal"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.tanggal">
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider 
                            name="Tanggal" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              readonly
                              filled
                              rounded
                              dense
                              :color="set_color"
                              placeholder="Contoh. 2023-12-30"
                              hide-details
                              clearable

                              @click:clear="form.template_meta_json_object.tanggal = null;"
                              v-on="on"
                              v-bind="attrs"

                              v-model="form.template_meta_json_object.tanggal"
                              :success="form.template_meta_json_object.tanggal !== null && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px; width: 40%;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>

                        <v-date-picker 
                          :color="set_color"
                          v-model="form.template_meta_json_object.tanggal"
                          @input="picker.tanggal = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <v-btn
                      @click="add_pegawai()"

                      color="#444444"
                      elevation="0"
                      class="text-capitalize white--text mb-4"
                      style="border-radius: 10px;">
                      Tambah Pegawai Yang Diundang
                    </v-btn>

                    <div
                      v-for="(item, index) in form.template_meta_json_object.kepada"
                      :key="index">
                      <v-card
                        flat
                        class="pa-3 mb-6"
                        style="border: 2px dashed #f0f0f0; border-radius: 10px;">
                        <v-btn
                          @click="form.template_meta_json_object.kepada.splice(index, 1)"

                          icon
                          style="position: absolute; top: -15px; right: -15px;">
                          <v-icon
                            color="red">
                            mdi-close-circle
                          </v-icon>
                        </v-btn>

                        <ValidationProvider 
                          :name="`Nama Yang Diundang ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Nama Yang Diundang {{ index + 1 }}
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            filled
                            rounded
                            dense
                            :color="set_color"
                            
                            placeholder="Contoh. Wildan Faizal Imawan"
                            hide-details

                            v-model="item.nama"
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Nama Yang Diundang {{ index + 1 }} {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="item.nama !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          :name="`Jabatan Yang Diundang ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Jabatan Yang Diundang {{ index + 1 }}
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            filled
                            rounded
                            dense
                            :color="set_color"
                            
                            placeholder="Contoh. Direktur Utama"
                            hide-details

                            v-model="item.unit"
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-3"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jabatan Yang Diundang {{ index + 1 }} {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="item.unit !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-card>
                    </div>

                    <v-row>
                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Hari/Tanggal
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="hari_tanggal"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.tanggal_mulai">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Hari/Tanggal" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-25"
                                  hide-details
                                  clearable

                                  @click:clear="form.template_meta_json_object.hari_tanggal = null;"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.hari_tanggal"
                                  :success="form.template_meta_json_object.hari_tanggal !== null && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Hari/Tanggal {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.hari_tanggal !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              v-model="form.template_meta_json_object.hari_tanggal"
                              @input="picker.tanggal_mulai = false">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="5"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Pukul
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="pukul"
                            v-model="time.pukul"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.template_meta_json_object.pukul"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Pukul" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  readonly
                                  
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 09:00"
                                  hide-details

                                  clearable
                                  @click:clear="form.template_meta_json_object.pukul = null"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.template_meta_json_object.pukul"
                                  :success="valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Pukul {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.template_meta_json_object.pukul !== null && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-time-picker
                              v-if="time.pukul"
                              v-model="form.template_meta_json_object.pukul"
                              full-width
                              :color="set_color"
                              format="24hr"
                              @click:minute="$refs.pukul.save(`${form.template_meta_json_object.pukul}`);">
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>

                    <ValidationProvider 
                      name="Tempat" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tempat
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Gedung Sportorium UMY, Lantai Dasar"
                        hide-details

                        v-model="form.template_meta_json_object.tempat"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tempat {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.tempat !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Penceramah" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Penceramah
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Ust. Talqis Nurdianto, Lc., MA"
                        hide-details

                        v-model="form.template_meta_json_object.penceramah"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Penceramah {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.penceramah !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Nama Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
                        hide-details

                        v-model="form.template_meta_json_object.nama_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Jabatan Yang Bertandatangan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Jabatan Yang Bertandatangan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        
                        placeholder="Contoh. Direktur Utama PT.UMB."
                        hide-details

                        v-model="form.template_meta_json_object.jabatan_1"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Jabatan Yang Bertandatangan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                      <div
                        ref="arsippdf"
                        style="padding: 50px;">
                        <v-card-text
                          class="black--text py-2">
                          <v-row>
                            <v-col
                              cols="12"
                              md="7">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Nomor
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Lampiran
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  Hal
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="8"
                                  class="py-0 d-flex align-start"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: flex-start !important;">
                                  : <span class="ml-1" style="font-weight: 500; margin-left: 4px !important;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                                </v-col>
                              </v-row>
                            </v-col>

                            <v-col
                              cols="12"
                              md="5">
                              <div
                                class="text-right"
                                style="text-align: right !important;">
                                Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                              </div>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-6"
                            style="margin-top: 24px !important;">
                            <div
                              style="margin-bottom: 1px;">
                              Kepada Yth.
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              Bapak/Ibu/Saudara/i
                            </div>

                            <div
                              v-for="(item, index) in form.template_meta_json_object.kepada"
                              :key="index"
                              class="d-flex align-center"
                              style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                              <span>
                                {{ index + 1 }}.
                              </span>

                              <span
                                class="mx-2"
                                style="margin-right: 8px !important; margin-left: 8px !important;">
                                {{ item.nama !== '' ? item.nama : '__________' }}
                              </span>

                              <span>
                                ({{ item.unit !== '' ? item.unit : '__________' }})
                              </span>
                            </div>

                            <div
                              style="margin-bottom: 1px;">
                              di lingkungan PT. Umat Mandiri Berkemajuan
                            </div>
                          </div>

                          <div
                            class="mt-10"
                            style="margin-top: 40px !important;">
                            <v-img
                              contain
                              width="175"
                              height="auto"
                              alt="umb" 
                              :src="require('@/assets/image/assalam.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div
                              class="my-4"
                              style="margin-top: 16px !important; margin-bottom: 16px !important;">
                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Puji Syukur kehadirat Allah SWT yang telah melimpahkan berkah rahmat-Nya dan kesehatan kepada kita semua sehingga kita masih diberikan kesempatan melakukan aktivitas sehari-hari. Sholawat serta salam tidak lupa selalu kita haturkan pada junjungan kita Nabi Muhammad SAW, para sahabat dan para pengikut-Nya sebagai tauladan sampai akhir zaman. Aamiin. 
                              </div>

                              <div
                                class="mb-4"
                                style="text-indent: 30px; margin-bottom: 16px !important;">
                                Dengan ini kami bermaksud mengundang Bapak/Ibu/Saudara/i untuk menghadiri acara Pengajian dan Buka Bersama Keluarga Besar PT. Umat Mandiri Berkemajuan, yang insyaAllah akan diselenggarakan pada :
                              </div>

                              <div
                                class="mb-4"
                                style="margin-bottom: 16px !important;">
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Hari/Tanggal
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    : 
                                    <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                                      {{ form.template_meta_json_object.hari_tanggal | weekday }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>
                                    
                                    ,

                                    <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                                      {{ form.template_meta_json_object.hari_tanggal | fulldate }}
                                    </span>

                                    <span v-else>
                                      __________
                                    </span>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Pukul
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    : {{ form.template_meta_json_object.pukul !== '' ? form.template_meta_json_object.pukul : '__________' }} s/d Selesai
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Tempat
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0 d-flex align-start"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; lign-items: flex-start !important;">
                                    : 
                                    <span
                                      class="ml-1"
                                      style="margin-left: 4px !important;">
                                      {{ form.template_meta_json_object.tempat !== '' ? form.template_meta_json_object.tempat : '__________' }}
                                    </span>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="3"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    Penceramah
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="9"
                                    class="py-0"
                                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    : {{ form.template_meta_json_object.penceramah !== '' ? form.template_meta_json_object.penceramah : '__________' }}
                                  </v-col>
                                </v-row>
                              </div>

                              <div
                                style="text-indent: 30px;">
                                Demikian surat undangan ini kami sampaikan, atas perhatian dan kerjasamanya kami ucapkan terima kasih.
                              </div>
                            </div>

                            <v-img
                              contain
                              width="175"
                              height="auto"
                              alt="umb" 
                              :src="require('@/assets/image/wassalam.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>

                          <v-row
                            justify="end"
                            class="mt-8"
                            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                            <v-col
                              cols="12"
                              md="6"
                              class="text-center"
                              style="text-align: center !important;">
                              <div>
                                Hormat kami,
                              </div>

                              <div
                                class="mb-16"
                                style="margin-bottom: 64px !important;">
                                {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                              </div>

                              <div>
                                {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save_from_template()"
            @click="save_from_template()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.from_template = false; dialog.fullscreen = false; dialog.form = form.id === '' ? true : false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.move"
      @keydown.esc="dialog.move = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          Pindah ke Folder

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.move = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider
                name="Pilih Folder" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pilih Folder
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-autocomplete
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Surat Menyurat"
                  
                  :items="parents"
                  item-value="id"
                  item-text="title"
                  :item-color="set_color"

                  v-model="form.par_id"
                  :success="form.par_id !== '' && valid"
                  :error-messages="errors"
                  required
                  class="mb-3"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pilih Folder {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.par_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save_move()"
            @click="save_move()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.move = false; dialog.fullscreen = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PREVIEW AND DOWNLOAD -->
    <v-dialog v-model="dialog.pdf_preview"
      @keydown.esc="dialog.pdf_preview = false; dialog.form = true;"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          Preview {{ selected.preview.title }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.pdf_preview = false; dialog.fullscreen = false; selected.preview = {};"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <div v-if="selected.preview.template_id == 0">
            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                id="arsippdf"
                ref="arsippdf">
                <iframe v-if="selected.preview.url !== ''"
                  :src="`${selected.preview.url}#toolbar=0`" 
                  allowfullscreen
                  frameborder="0" 
                  width="100%"
                  height="750"
                  style="border-radius: 10px; border: 2px solid #323639;">
                </iframe>
              </div>
            </v-card>
          </div>

          <div v-if="selected.preview.template_id == 1">
            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                id="arsippdf"
                ref="arsippdf"
                style="padding: 50px;">
                <v-card-title
                  class="d-flex justify-center black--text text-uppercase mb-4"
                  style="text-transform: uppercase !important; margin-bottom: 16px !important; display: flex !important; justify-content: center !important; font-size: 1.25rem; font-weight: 500; line-height: 2rem; padding: 16px ">
                  {{ selected.preview.template_meta_json_object.judul }}
                </v-card-title>

                <v-card-text
                  class="black--text">
                  <v-row>
                    <v-col
                      cols="12"
                      md="7">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          No.
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nomor !== '' ? selected.preview.template_meta_json_object.nomor : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Hal
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.judul !== '' ? selected.preview.template_meta_json_object.judul : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Lampiran
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.lampiran !== '' ? selected.preview.template_meta_json_object.lampiran : '__________' }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                      cols="12"
                      md="5">
                      <div
                        class="text-right"
                        style="text-align: right !important;">
                        Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
                      </div>
                    </v-col>
                  </v-row>

                  <div
                    class="mt-6"
                    style="margin-top: 24px !important;">
                    <div
                      class="mb-2"
                      style="margin-bottom: 8px !important;">
                      Yang bertandatangan di bawah ini:
                    </div>

                    <div
                      class="px-8"
                      style="padding-right: 32px !important; padding-left: 32px !important;">
                      <v-row>
                        <v-col
                          cols="12"
                          md="2"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nama
                        </v-col>

                        <v-col
                          cols="12"
                          md="10"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="2"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Jabatan
                        </v-col>

                        <v-col
                          cols="12"
                          md="10"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                        </v-col>
                      </v-row>
                    </div>
                  </div>

                  <div
                    class="mt-2"
                    style="margin-top: 8px !important;">
                    <div
                      class="mb-2"
                      style="margin-bottom: 8px !important;">
                      Dengan ini menerangkan bahwa yang bersangkutan di bawah ini:
                    </div>

                    <div
                      class="px-8"
                      style="padding-right: 32px !important; padding-left: 32px !important;">
                      <v-row>
                        <v-col
                          cols="12"
                          md="2"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nama
                        </v-col>

                        <v-col
                          cols="12"
                          md="10"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nama_2 !== '' ? selected.preview.template_meta_json_object.nama_2 : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="2"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Alamat
                        </v-col>

                        <v-col
                          cols="12"
                          md="10"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          <div
                            class="d-flex align-start"
                            style="display: flex !important; align-items: flex-start !important;">
                            <div>
                              :
                            </div>

                            <div
                              class="ml-1"
                              style="margin-left: 4px !important;">
                              {{ selected.preview.template_meta_json_object.alamat_2 !== '' ? selected.preview.template_meta_json_object.alamat_2 : '__________' }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>

                  <div
                    class="mt-8"
                    style="margin-top: 32px !important;">
                    <div
                      class="mb-2"
                      style="margin-bottom: 8px !important;">
                      Karyawan tersebut benar telah bekerja di {{ selected.preview.template_meta_json_object.unit !== '' ? selected.preview.template_meta_json_object.unit : '__________' }} sejak
                      <span v-if="selected.preview.template_meta_json_object.tanggal_mulai !== '' && selected.preview.template_meta_json_object.tanggal_mulai !== null">
                        {{ selected.preview.template_meta_json_object.tanggal_mulai | fulldate }} 
                      </span>

                      <span v-else>
                        __________
                      </span>
                      sampai dengan
                      <span v-if="selected.preview.template_meta_json_object.tanggal_selesai !== '' && selected.preview.template_meta_json_object.tanggal_selesai !== null">
                        {{ selected.preview.template_meta_json_object.tanggal_selesai | fulldate }} 
                      </span>

                      <span v-else>
                        __________
                      </span>
                      Adapun jabatan terakhir saudara adalah sebagai {{ selected.preview.template_meta_json_object.jabatan_2 !== '' ? selected.preview.template_meta_json_object.jabatan_2 : '__________' }}.
                    </div>

                    <div
                      class="mb-2"
                      style="margin-bottom: 8px !important;">
                      Selama bekerja di {{ selected.preview.template_meta_json_object.unit !== '' ? selected.preview.template_meta_json_object.unit : '__________' }}, Saudara telah memberikan dedikasi dan loyalitasnya yang besar terhadap perusahaan serta tak pernah sekalipun melakukan hal – hal yang merugikan perusahaan. Dalam hal ini saudara {{ selected.preview.template_meta_json_object.nama_2 !== '' ? selected.preview.template_meta_json_object.nama_2 : '__________' }} mengundurkan diri karena {{ selected.preview.template_meta_json_object.alasan !== '' ? selected.preview.template_meta_json_object.alasan : '__________' }}.
                    </div>

                    <div
                      class="mb-2"
                      style="margin-bottom: 8px !important;">
                      Kami sangat berterimakasih atas kerja kerasnya selama ini dan mengharapkan saudara dapat sukses pada masa mendatang.
                    </div>

                    <div>
                      Demikian surat paklaring ini kami buat agar dapat dipergunakan dengan semestinya. Atas perhatiannya, kami ucapkan terimakasih.
                    </div>

                    <v-row
                      justify="end"
                      class="mt-8"
                      style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                      <v-col
                        cols="12"
                        md="6"
                        class="text-center"
                        style="text-align: center !important;">
                        <div>
                          Hormat Kami,
                        </div>

                        <div
                          class="mb-16"
                          style="margin-bottom: 64px !important;">
                          {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                        </div>

                        <div>
                          {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </div>
            </v-card>
          </div>

          <div v-if="selected.preview.template_id == 4">
            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                ref="arsippdf"
                style="padding: 50px;">
                <v-card-text
                  class="black--text py-2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="7">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nomor
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nomor !== '' ? selected.preview.template_meta_json_object.nomor : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Lampiran
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.lampiran !== '' ? selected.preview.template_meta_json_object.lampiran : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Hal
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ selected.preview.template_meta_json_object.hal !== '' ? selected.preview.template_meta_json_object.hal : '__________' }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <div
                    class="mt-6"
                    style="margin-top: 24px !important;">
                    <div
                      style="margin-bottom: 1px;">
                      Kepada Yth.
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      {{ selected.preview.template_meta_json_object.nama_2 !== '' ? selected.preview.template_meta_json_object.nama_2 : '__________' }}
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      {{ selected.preview.template_meta_json_object.jabatan_2 !== '' ? selected.preview.template_meta_json_object.jabatan_2 : '__________' }}
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      di tempat.
                    </div>
                  </div>

                  <div
                    class="mt-10"
                    style="margin-top: 40px !important;">
                    <v-img
                      contain
                      width="175"
                      height="auto"
                      alt="umb" 
                      :src="require('@/assets/image/assalam.jpeg')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div
                      class="my-4"
                      style="margin-top: 16px !important; margin-bottom: 16px !important;">
                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Puji Syukur kehadirat Allah SWT yang telah melimpahkan berkah rahmat-Nya dan kesehatan kepada kita semua sehingga kita masih diberikan kesempatan melakukan aktivitas sehari-hari. Sholawat serta salam tidak lupa selalu kita haturkan pada junjungan kita Nabi Muhammad SAW, para sahabat dan para pengikut-Nya sebagai tauladan sampai akhir zaman. Aamiin. 
                      </div>

                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Dengan surat ini, kami (PT.  Umat Mandiri Berkemajuan) bermaksud memberitahukan bahwasannya saat ini saudara {{ selected.preview.template_meta_json_object.nama_2 !== '' ? selected.preview.template_meta_json_object.nama_2 : '__________' }} masih menjadi {{ selected.preview.template_meta_json_object.jabatan_2 !== '' ? selected.preview.template_meta_json_object.jabatan_2 : '__________' }}, maka dari itu masih berkewenangan {{ selected.preview.template_meta_json_object.tujuan !== '' ? selected.preview.template_meta_json_object.tujuan : '__________' }} PT. Umat Mandiri Berkemajuan.
                      </div>

                      <div
                        style="text-indent: 30px;">
                        Demikian surat ini kami sampaikan, atas perhatian dan kerjasamanya kami ucapkan terima kasih.
                      </div>
                    </div>

                    <v-img
                      contain
                      width="175"
                      height="auto"
                      alt="umb" 
                      :src="require('@/assets/image/wassalam.jpeg')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <v-row
                    justify="end"
                    class="mt-8"
                    style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                    <v-col
                      cols="12"
                      md="6"
                      class="text-center"
                      style="text-align: center !important;">
                      <div>
                        Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
                      </div>

                      <div
                        class="mb-16"
                        style="margin-bottom: 64px !important;">
                        {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                      </div>

                      <div>
                        {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-card>
          </div>

          <div v-if="selected.preview.template_id == 5">
            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                ref="arsippdf"
                style="padding: 50px;">
                <v-card-text
                  class="black--text py-2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="7">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nomor
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nomor !== '' ? selected.preview.template_meta_json_object.nomor : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Lampiran
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.lampiran !== '' ? selected.preview.template_meta_json_object.lampiran : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Hal
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ selected.preview.template_meta_json_object.hal !== '' ? selected.preview.template_meta_json_object.hal : '__________' }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <div
                    class="mt-6"
                    style="margin-top: 24px !important;">
                    <div
                      style="margin-bottom: 1px;">
                      Kepada Yth.
                    </div>

                    <div
                      v-for="(item, index) in selected.preview.template_meta_json_object.kepada"
                      :key="index"
                      class="d-flex align-center"
                      style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                      <span>
                        {{ index + 1 }}.
                      </span>

                      <span
                        class="mx-2"
                        style="margin-right: 8px !important; margin-left: 8px !important;">
                        {{ item.nama !== '' ? item.nama : '__________' }}
                      </span>

                      <span>
                        ({{ item.unit !== '' ? item.unit : '__________' }})
                      </span>
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      di lingkungan PT. Umat Mandiri Berkemajuan
                    </div>
                  </div>

                  <div
                    class="mt-10"
                    style="margin-top: 40px !important;">
                    <v-img
                      contain
                      width="175"
                      height="auto"
                      alt="umb" 
                      :src="require('@/assets/image/assalam.jpeg')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div
                      class="my-4"
                      style="margin-top: 16px !important; margin-bottom: 16px !important;">
                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Dengan hormat, sehubungan dengan memasukinya {{ selected.preview.template_meta_json_object.hari_libur !== '' ? selected.preview.template_meta_json_object.hari_libur : '__________' }}, maka bersama surat ini kami sampaikan informasi sebagai berikut :
                      </div>

                      <div
                        class="mb-4"
                        style="margin-left: 22px; margin-bottom: 16px !important;">
                        <ol
                          type="a">
                          <li
                            class="pl-2"
                            style="padding-left: 8px !important;">
                            Libur menjelang {{ selected.preview.template_meta_json_object.hari_libur !== '' ? selected.preview.template_meta_json_object.hari_libur : '__________' }} dimulai pada tanggal
                            <span v-if="selected.preview.template_meta_json_object.tanggal_mulai !== '' && selected.preview.template_meta_json_object.tanggal_mulai !== null">
                              {{ selected.preview.template_meta_json_object.tanggal_mulai | day }}
                            </span>

                            <span v-else>
                              __________
                            </span>

                            -

                            <span v-if="selected.preview.template_meta_json_object.tanggal_selesai !== '' && selected.preview.template_meta_json_object.tanggal_selesai !== null">
                              {{ selected.preview.template_meta_json_object.tanggal_selesai | fulldate }}
                            </span>

                            <span v-else>
                              __________
                            </span>
                          </li>

                          <li
                            class="pl-2"
                            style="padding-left: 8px !important;">
                            Kegiatan dan aktifitas di lingkungan PT. UMB mulai aktif kembali pada tanggal
                            <span v-if="selected.preview.template_meta_json_object.tanggal_masuk !== '' && selected.preview.template_meta_json_object.tanggal_masuk !== null">
                              {{ selected.preview.template_meta_json_object.tanggal_masuk | fulldate }}
                            </span>

                            <span v-else>
                              __________
                            </span>
                          </li>

                          <li
                            class="pl-2"
                            style="padding-left: 8px !important;">
                            Informasi atau kebijakan lain {{ selected.preview.template_meta_json_object.informasi_lain !== '' ? selected.preview.template_meta_json_object.informasi_lain : '__________' }}.
                          </li>
                        </ol>
                      </div>

                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Selanjutnya, mohon bagi pimpinan unit bisnis PT. UMB untuk menyampaikan infromasi tersebut di unit bisnis masing-masing.
                      </div>

                      <div
                        style="text-indent: 30px;">
                        Demikian pemberitahuan ini kami sampaikan atas perhatian dan kerjasamanya diucapkan terima kasih.
                      </div>
                    </div>

                    <v-img
                      contain
                      width="175"
                      height="auto"
                      alt="umb" 
                      :src="require('@/assets/image/wassalam.jpeg')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <v-row
                    justify="end"
                    class="mt-8"
                    style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                    <v-col
                      cols="12"
                      md="6"
                      class="text-center"
                      style="text-align: center !important;">
                      <div>
                        Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
                      </div>

                      <div
                        class="mb-16"
                        style="margin-bottom: 64px !important;">
                        {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                      </div>

                      <div>
                        {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-card>
          </div>

          <div v-if="selected.preview.template_id == 3">
            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                ref="arsippdf"
                style="padding: 50px;">
                <v-card-text
                  class="black--text py-2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="7">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nomor
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nomor !== '' ? selected.preview.template_meta_json_object.nomor : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Lampiran
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.lampiran !== '' ? selected.preview.template_meta_json_object.lampiran : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Hal
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0 d-flex align-start"
                          style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: flex-start !important;">
                          : <span class="ml-1" style="font-weight: 500; margin-left: 4px !important;">{{ selected.preview.template_meta_json_object.hal !== '' ? selected.preview.template_meta_json_object.hal : '__________' }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <div
                    class="mt-6"
                    style="margin-top: 24px !important;">
                    <div
                      style="margin-bottom: 1px;">
                      Kepada Yth.
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      Bapak/Ibu/Saudara/i
                    </div>

                    <div
                      v-for="(item, index) in selected.preview.template_meta_json_object.kepada"
                      :key="index"
                      class="d-flex align-center"
                      style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                      <span>
                        {{ index + 1 }}.
                      </span>

                      <span
                        class="mx-2"
                        style="margin-right: 8px !important; margin-left: 8px !important;">
                        {{ item.nama !== '' ? item.nama : '__________' }}
                      </span>

                      <span>
                        ({{ item.unit !== '' ? item.unit : '__________' }})
                      </span>
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      di lingkungan PT. Umat Mandiri Berkemajuan
                    </div>
                  </div>

                  <div
                    class="mt-10"
                    style="margin-top: 40px !important;">
                    <div
                      class="font-italic"
                      style="font-weight: 500; font-style: italic !important;">
                      Assalamu’alaikum wr.wb.
                    </div>

                    <div
                      class="my-4"
                      style="margin-top: 16px !important; margin-bottom: 16px !important;">
                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Puji syukur kita panjatkan kepada Allah SWT yang telah memberikan berkah rahmat-Nya dan kesehatan kepada kita semua sehingga kita masih dapat melakukan aktivitas kita sehari-hari. Sholawat dan salam tidak lupa selalu kita haturkan kepada junjungan kita Nabi Muhammad SAW, para sahabat dan para pengikut-Nya sebagai tauladan sampai akhir zaman. Aamin.
                      </div>

                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Sehubungan dengan penyempurnaan sistem SDM di PT. UMB, maka bersama surat ini kami bermaksud mengundang Bapak/Ibu pada :
                      </div>

                      <div
                        class="mb-4"
                        style="margin-bottom: 16px !important;">
                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Hari/Tanggal
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            : 
                            <span v-if="selected.preview.template_meta_json_object.hari_tanggal !== '' && selected.preview.template_meta_json_object.hari_tanggal !== null">
                              {{ selected.preview.template_meta_json_object.hari_tanggal | weekday }}
                            </span>

                            <span v-else>
                              __________
                            </span>
                            
                            ,

                            <span v-if="selected.preview.template_meta_json_object.hari_tanggal !== '' && selected.preview.template_meta_json_object.hari_tanggal !== null">
                              {{ selected.preview.template_meta_json_object.hari_tanggal | fulldate }}
                            </span>

                            <span v-else>
                              __________
                            </span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Pukul
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            : {{ selected.preview.template_meta_json_object.pukul !== '' ? selected.preview.template_meta_json_object.pukul : '__________' }} s/d Selesai
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Tempat
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0 d-flex align-start"
                            style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: start !important;">
                            : 
                            <span
                              class="ml-1"
                              style="margin-left: 4px !important;">
                              {{ selected.preview.template_meta_json_object.tempat !== '' ? selected.preview.template_meta_json_object.tempat : '__________' }}
                            </span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Agenda
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0 d-flex align-start"
                            style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: start !important;">
                            : 
                            <span v-if="selected.preview.template_meta_json_object.agenda !== ''"
                              class="ml-1 from_html"
                              style="margin-left: 4px !important;"
                              v-html="selected.preview.template_meta_json_object.agenda">
                            </span>

                            <span v-else
                              class="ml-1"
                              style="margin-left: 4px !important;">
                              __________
                            </span>
                          </v-col>
                        </v-row>

                        <v-row
                          class="mt-4">
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="font-weight: 500; padding-top: 0px !important; padding-bottom: 0px !important;">
                            Catatan
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0 d-flex align-start"
                            style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: start !important;">
                            : 
                            <span v-if="selected.preview.template_meta_json_object.catatan !== ''"
                              class="ml-1 from_html"
                              style="margin-left: 4px !important;"
                              v-html="selected.preview.template_meta_json_object.catatan">
                            </span>

                            <span v-else
                              class="ml-1"
                              style="margin-left: 4px !important;">
                              __________
                            </span>
                          </v-col>
                        </v-row>
                      </div>

                      <div
                        style="text-indent: 30px;">
                        Demikian surat undangan ini kami sampaikan, atas perhatian dan kerjasamanya diucapkan terima kasih.
                      </div>
                    </div>

                    <div
                      class="font-italic"
                      style="font-weight: 500; font-style: italic !important;">
                      Wassalamu’alaikum wr.wb.
                    </div>
                  </div>

                  <v-row
                    justify="end"
                    class="mt-8"
                    style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                    <v-col
                      cols="12"
                      md="6"
                      class="text-center"
                      style="text-align: center !important;">
                      <div>
                        Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
                      </div>

                      <div
                        class="mb-16"
                        style="margin-bottom: 64px !important;">
                        {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                      </div>

                      <div>
                        {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-card>
          </div>

          <div v-if="selected.preview.template_id == 2">
            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                ref="arsippdf"
                style="padding: 50px;">
                <v-card-text
                  class="black--text py-2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="7">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nomor
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.nomor !== '' ? selected.preview.template_meta_json_object.nomor : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Lampiran
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : {{ selected.preview.template_meta_json_object.lampiran !== '' ? selected.preview.template_meta_json_object.lampiran : '__________' }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Hal
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0 d-flex align-start"
                          style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; align-items: flex-start !important;">
                          : <span class="ml-1" style="font-weight: 500; margin-left: 4px !important;">{{ selected.preview.template_meta_json_object.hal !== '' ? selected.preview.template_meta_json_object.hal : '__________' }}</span>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                      cols="12"
                      md="5">
                      <div
                        class="text-right"
                        style="text-align: right !important;">
                        Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
                      </div>
                    </v-col>
                  </v-row>

                  <div
                    class="mt-6"
                    style="margin-top: 24px !important;">
                    <div
                      style="margin-bottom: 1px;">
                      Kepada Yth.
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      Bapak/Ibu/Saudara/i
                    </div>

                    <div
                      v-for="(item, index) in selected.preview.template_meta_json_object.kepada"
                      :key="index"
                      class="d-flex align-center"
                      style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                      <span>
                        {{ index + 1 }}.
                      </span>

                      <span
                        class="mx-2"
                        style="margin-right: 8px !important; margin-left: 8px !important;">
                        {{ item.nama !== '' ? item.nama : '__________' }}
                      </span>

                      <span>
                        ({{ item.unit !== '' ? item.unit : '__________' }})
                      </span>
                    </div>

                    <div
                      style="margin-bottom: 1px;">
                      di lingkungan PT. Umat Mandiri Berkemajuan
                    </div>
                  </div>

                  <div
                    class="mt-10"
                    style="margin-top: 40px !important;">
                    <v-img
                      contain
                      width="175"
                      height="auto"
                      alt="umb" 
                      :src="require('@/assets/image/assalam.jpeg')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div
                      class="my-4"
                      style="margin-top: 16px !important; margin-bottom: 16px !important;">
                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Puji Syukur kehadirat Allah SWT yang telah melimpahkan berkah rahmat-Nya dan kesehatan kepada kita semua sehingga kita masih diberikan kesempatan melakukan aktivitas sehari-hari. Sholawat serta salam tidak lupa selalu kita haturkan pada junjungan kita Nabi Muhammad SAW, para sahabat dan para pengikut-Nya sebagai tauladan sampai akhir zaman. Aamiin. 
                      </div>

                      <div
                        class="mb-4"
                        style="text-indent: 30px; margin-bottom: 16px !important;">
                        Dengan ini kami bermaksud mengundang Bapak/Ibu/Saudara/i untuk menghadiri acara Pengajian dan Buka Bersama Keluarga Besar PT. Umat Mandiri Berkemajuan, yang insyaAllah akan diselenggarakan pada :
                      </div>

                      <div
                        class="mb-4"
                        style="margin-bottom: 16px !important;">
                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Hari/Tanggal
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            : 
                            <span v-if="selected.preview.template_meta_json_object.hari_tanggal !== '' && selected.preview.template_meta_json_object.hari_tanggal !== null">
                              {{ selected.preview.template_meta_json_object.hari_tanggal | weekday }}
                            </span>

                            <span v-else>
                              __________
                            </span>
                            
                            ,

                            <span v-if="selected.preview.template_meta_json_object.hari_tanggal !== '' && selected.preview.template_meta_json_object.hari_tanggal !== null">
                              {{ selected.preview.template_meta_json_object.hari_tanggal | fulldate }}
                            </span>

                            <span v-else>
                              __________
                            </span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Pukul
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            : {{ selected.preview.template_meta_json_object.pukul !== '' ? selected.preview.template_meta_json_object.pukul : '__________' }} s/d Selesai
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Tempat
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0 d-flex align-start"
                            style="padding-top: 0px !important; padding-bottom: 0px !important; display: flex !important; lign-items: flex-start !important;">
                            : 
                            <span
                              class="ml-1"
                              style="margin-left: 4px !important;">
                              {{ selected.preview.template_meta_json_object.tempat !== '' ? selected.preview.template_meta_json_object.tempat : '__________' }}
                            </span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            Penceramah
                          </v-col>

                          <v-col
                            cols="12"
                            md="9"
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            : {{ selected.preview.template_meta_json_object.penceramah !== '' ? selected.preview.template_meta_json_object.penceramah : '__________' }}
                          </v-col>
                        </v-row>
                      </div>

                      <div
                        style="text-indent: 30px;">
                        Demikian surat undangan ini kami sampaikan, atas perhatian dan kerjasamanya kami ucapkan terima kasih.
                      </div>
                    </div>

                    <v-img
                      contain
                      width="175"
                      height="auto"
                      alt="umb" 
                      :src="require('@/assets/image/wassalam.jpeg')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <v-row
                    justify="end"
                    class="mt-8"
                    style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                    <v-col
                      cols="12"
                      md="6"
                      class="text-center"
                      style="text-align: center !important;">
                      <div>
                        Hormat kami,
                      </div>

                      <div
                        class="mb-16"
                        style="margin-bottom: 64px !important;">
                        {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                      </div>

                      <div>
                        {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-card>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="exportToPDF()">
            <v-icon small class="mr-1">mdi-file-download-outline</v-icon>
            Download
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.pdf_preview = false; dialog.fullscreen = false; selected.preview = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div v-if="$route.query.par_id !== undefined"
                  class="mr-3">
                  <v-btn
                    @click="$router.go(-1)"
                    elevation="0"
                    min-width="36"
                    style="border-radius: 10px;"
                    color="#f0f0f0"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center px-0">
                    <v-icon size="18">mdi-arrow-u-left-top-bold</v-icon>
                  </v-btn>
                </div>

                <div class="mr-3">
                  <v-menu
                    transition="slide-x-transition"
                    bottom
                    right
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"

                        elevation="0"
                        style="background: #4caf5033; border-radius: 10px;"
                        class="body-2 text-capitalize font-weight-bold d-flex align-center green--text">
                        <v-icon size="18">mdi-plus-circle-outline</v-icon>

                        <span class="ml-1">
                          Tambah
                        </span>
                      </v-btn>
                    </template>

                    <v-list
                      dense>
                      <v-list-item
                        v-for="(item, index) in menu_add"
                        :key="index"
                        @click="selected.menu_add = item.text; dialog.form = true; reset();"
                        class="px-2">
                        <v-list-item-avatar
                          class="ma-0">
                          <v-icon
                            size="22">
                            {{ item.icon }}
                          </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title
                            class="body-2 text-capitalize">
                            {{ item.text }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <div class="ml-3">
                  <div
                    class="d-flex align-center">
                    <v-btn
                      v-for="(item, index) in menu"
                      :key="index"
                      @click="selected.menu = item.text"

                      :color="selected.menu === item.text ? set_color : '#f0f0f0'"
                      elevation="0"
                      min-width="36"
                      class="text-capitalize px-0"

                      :class="selected.menu === item.text ? 'white--text' : ''"
                      :style="index > 0 ? 'border-radius: 0px 10px 10px 0px;' : 'border-radius: 10px 0px 0px 10px;'">
                      <v-icon>
                        {{ item.icon }}
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <div v-if="selected.menu === 'table'">
            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
              :show-select="checkbox"
              :single-select="true"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="configHeaders"
              :items="list"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              @dblclick:row="doubleClick"
              hide-default-footer>
              <template
                v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                v-slot:[`item.${header.value}`]="{ value, index }">
                <div
                  v-bind:key="header.value">
                  <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link' && header.format !== 'size'">
                    {{ rowFormat(header.format, value) }} 
                  </div>

                  <div v-if="header.format === 'link'"
                    @click="toLink(index)"
                    class="cursor-pointer">
                    <div
                      class="d-flex align-start">
                      <v-icon 
                        size="22"
                        class="mr-2"
                        :color="list[index].type === 'FOLDER' ? '' : 'blue'">
                        {{ list[index].type === 'FOLDER' ? 'mdi-folder' : 'mdi-file-word-box' }}
                      </v-icon>

                      <span
                        style="font-weight: 500;">
                        {{ value }}
                      </span>
                    </div>
                  </div>
    
                  <div v-if="header.format === 'size'">
                    {{ value > 0 ? `${Math.round(value / 1000000)} Mb` : '-' }}
                  </div>

                  <div v-if="header.format === 'action'">
                    <v-menu
                      transition="slide-x-transition"
                      bottom
                      right
                      offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"

                          icon>
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list v-if="list[index].type === 'FOLDER'"
                        dense>
                        <v-list-item
                          v-for="(item_folder, index_folder) in menu_action.folder"
                          :key="index_folder"
                          @click="toAction(item_folder.text, list[index])"
                          class="pl-0 pr-3">
                          <v-list-item-avatar
                            class="ma-0">
                            <v-icon
                              size="20">
                              {{ item_folder.icon }}
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title
                              class="body-2 text-capitalize">
                              {{ item_folder.text }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>

                      <v-list v-if="list[index].type === 'FILE'"
                        dense>
                        <v-list-item
                          v-for="(item_file, index_file) in menu_action.file"
                          :key="index_file"
                          @click="toAction(item_file.text, list[index])"
                          class="pl-0 pr-3">
                          <v-list-item-avatar
                            class="ma-0">
                            <v-icon
                              size="20">
                              {{ item_file.icon }}
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title
                              class="body-2 text-capitalize">
                              {{ item_file.text }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </div>

          <div v-if="selected.menu === 'card'">
            <v-card-text
              class="pt-0 pb-2"
              :style="`height: calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
              style="overflow-y: auto;">
              <!-- FOLDER -->
              <div>
                <div v-if="process.load || (!process.load && list.length > 0)"
                  class="body-1 mb-2"
                  style="font-weight: 500;">
                  Folder
                </div>

                <v-row v-if="process.load">
                  <v-col
                    cols="12"
                    md="3"
                    v-for="(item, index) in 4"
                    :key="index"
                    class="skeleton_folder">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                    </v-skeleton-loader>
                  </v-col>
                </v-row>

                <v-row v-if="!process.load">
                  <v-col
                    cols="12"
                    md="3"
                    v-for="(item, index) in list"
                    :key="index"
                    v-show="item.type === 'FOLDER'"
                    class="skeleton_folder">
                    <v-list v-if="!process.load && list.length > 0"
                      class="py-0"
                      color="#f0f0f0"
                      style="border-radius: 10px;">
                      <v-list-item
                        @click="toLink(index)">
                        <v-list-item-avatar
                          class="ml-0 mr-2">
                          <v-icon>mdi-folder</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title 
                            class="body-2 text-capitalize"
                            style="font-weight: 500;">
                            {{ item.title }}
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action
                          class="ma-0 ml-2">
                          <v-menu
                            transition="slide-x-transition"
                            bottom
                            right
                            offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"

                                icon>
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>

                            <v-list
                              dense>
                              <v-list-item
                                v-for="(item_action, index_action) in menu_action.folder"
                                :key="index_action"
                                @click="toAction(item_action.text, list[index])"
                                class="pl-0 pr-3">
                                <v-list-item-avatar
                                  class="ma-0">
                                  <v-icon
                                    size="20">
                                    {{ item_action.icon }}
                                  </v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title
                                    class="body-2 text-capitalize">
                                    {{ item_action.text }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </div>

              <!-- FILE -->
              <div>
                <div v-if="process.load || (!process.load && list.length > 0)"
                  class="body-1 my-2"
                  style="font-weight: 500;">
                  File
                </div>

                <v-row v-if="process.load">
                  <v-col
                    cols="12"
                    md="3"
                    v-for="(item, index) in 4"
                    :key="index">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                    </v-skeleton-loader>
                  </v-col>
                </v-row>

                <v-row v-if="!process.load">
                  <v-col
                    cols="12"
                    md="3"
                    v-for="(item, index) in list"
                    :key="index"
                    v-show="item.type === 'FILE'">
                    <v-card v-if="!process.load && list.length > 0"
                      flat
                      color="#f0f0f0"
                      style="border-radius: 10px;">
                      <v-list
                        flat
                        color="transparent"
                        class="py-0">
                        <v-list-item>
                          <v-list-item-avatar
                            class="ml-0 mr-2">
                            <v-icon color="blue">mdi-file-word-box</v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title 
                              class="body-2 text-capitalize">
                              {{ item.title }}
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action
                            class="ma-0 ml-2">
                            <v-menu
                              transition="slide-x-transition"
                              bottom
                              right
                              offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"

                                  icon>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>

                              <v-list
                                dense>
                                <v-list-item
                                  v-for="(item_action, index_action) in menu_action.file"
                                  :key="index_action"
                                  @click="toAction(item_action.text, list[index])"
                                  class="pl-0 pr-3">
                                  <v-list-item-avatar
                                    class="ma-0">
                                    <v-icon
                                      size="20">
                                      {{ item_action.icon }}
                                    </v-icon>
                                  </v-list-item-avatar>

                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="body-2 text-capitalize">
                                      {{ item_action.text }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>

                      <v-card-text
                        class="pt-0">
                        <v-img
                          height="200"
                          :src="require('@/assets/image/word_default.jpeg')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          share: false,
          delete: false,
          move: false,

          from_template: false,

          pdf_preview: false
        },

        search: '',
        search_template: '',

        filter: {
          
        },

        menu: [
          {
            text: 'table',
            icon: 'mdi-format-list-bulleted',
          },
          {
            text: 'card',
            icon: 'mdi-apps',
          }
        ],

        menu_add: [
          {
            text: 'folder',
            icon: 'mdi-folder'
          },
          {
            text: 'file',
            icon: 'mdi-file'
          }
        ],

        menu_action: {
          folder: [
            {
              text: 'pindah',
              icon: 'mdi-file-move-outline'
            },
            {
              text: 'share',
              icon: 'mdi-share-outline'
            },
            {
              text: 'ubah',
              icon: 'mdi-circle-edit-outline'
            },
            {
              text: 'hapus',
              icon: 'mdi-delete-circle-outline'
            }
          ],
          file: [
            {
              text: 'pindah',
              icon: 'mdi-file-move-outline'
            },
            {
              text: 'share',
              icon: 'mdi-share-outline'
            },
            {
              text: 'download',
              icon: 'mdi-download-outline'
            },
            {
              text: 'ubah',
              icon: 'mdi-circle-edit-outline'
            },
            {
              text: 'hapus',
              icon: 'mdi-delete-circle-outline'
            }
          ]
        },

        selected: {
          row: [],
          freeze: [],

          menu: 'table',

          menu_add: '',

          template_id: '',

          preview: {}
        },

        users: [],
        templates: [],
        units: [],
        parents: [],
        shared: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,
        
        autocomplete: {
          user: ''
        },

        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false
        },

        time: {
          pukul: false
        },

        form: {
          // FOLDER
          id: '',
          par_id: 0,
          title: '',

          // SHARE
          type: 'BY_USER',
          users: [{
            id: '',
            is_can_download: true,
            exp_datetime: null
          }],

          // FILE
          template_id: '',
          template_meta_json_object: {},

          extension: 'pdf',
          size: 0,
          url: '',
          original_url: '',
          mimetype: 'application/pdf'
        },

        upload: {
          doc: false
        },
        
        process: {
          load: false,

          form: false,
          user: false,

          delete: false,

          template: false,
          unit: false,
          parent: false,
          share: false,

          delete_share: false,

          doc: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_pdf.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },

      'autocomplete.user': function() {
        this.fetchUser()
      },

      $route (to, from){
        let pagination = { row: this.limit, page: 1 }
        this.fetch(pagination)
      },

      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.title = this.upload.doc.filename
              this.form.url = this.upload.doc.fileuri
              this.form.original_url = this.upload.doc.fileuri
              this.form.size = this.upload.doc.filesize
              this.form.mimetype = this.upload.doc.filemime
              this.form.extension = this.upload.doc.filemime.split('/')[1]
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // }
    },
    mounted () {
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = parseInt(value) + '%'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        } else if (format === 'size') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,

          par_id: this.$route.query.par_id !== undefined ? this.$route.query.par_id : 0
        }

        this.selected.row = []

        await get('files/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '75px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Nama',
                width: '400px',
                value: 'title',
                freeze: false,
                hide: false,
                format: 'link'
              },
              {
                text: 'Owner',
                width: '400px',
                value: 'input_user_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Terakhir Update',
                width: '200px',
                value: 'updated_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Ukuran File',
                width: '200px',
                value: 'size',
                freeze: false,
                hide: false,
                format: 'size'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            if (this.selected.menu === 'table') {
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.form = {
          id: item !== undefined ? item.id : '',
          par_id: item !== undefined ? item.par_id : this.$route.query.par_id !== undefined ? this.$route.query.par_id : 0,
          title: item !== undefined ? item.title : '',

          // SHARE
          type: 'BY_USER',
          users: [{
            id: '',
            is_can_download: true,
            exp_datetime: null
          }],

          // FILE
          template_id: item !== undefined ? item.template_id : '',
          template_meta_json_object: item !== undefined ? item.template_meta_json_object : '',

          extension: item !== undefined ? item.extension : 'pdf',
          size: item !== undefined ? item.size : 0,
          url: item !== undefined ? item.url : '',
          original_url: item !== undefined ? item.original_url : '',
          mimetype: item !== undefined ? item.mimetype : 'application/pdf'
        }

        this.picker = {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false
        }

        this.time = {
          pukul: false
        }

        this.process.form = false

        this.message.error = ''

        if (this.selected.menu_add === 'file') {
          this.selected.template_id = ''

          this.fetchTemplate()
        }

        this.fetchUnit()
      },

      async save_folder () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'files/add_folder' : 'files/update_folder'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false


            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toLink (index) {
        if (this.list[index].type === 'FOLDER') {
          this.$router.push( `/archive/folder?par_id=${this.list[index].id}`)
  
          this.fetch()
        } else {
          // this.generate_file(this.list[index].id)

          this.dialog.pdf_preview = true
          this.selected.preview = this.list[index]
        }
      },

      toAction (type, data) {
        this.reset(data)

        this.selected.menu_add = data.type === 'FOLDER' ? 'folder' : 'file'

        if (type === 'pindah') {
          this.fetchParent()

          this.dialog.move = true
        }

        if (type === 'share') {
          // this.fetchUser()

          this.fetchShare(data.id)

          this.dialog.share = true
        }

        if (type === 'download') {
          // this.generate_file(data.id)

          this.dialog.pdf_preview = true
          this.selected.preview = data
        }

        if (type === 'ubah') {
          if (Object.keys(data.template_meta_json_object).length > 0) {
            this.dialog.from_template = true
          } else {
            this.dialog.form = true
          }
        }

        if (type === 'hapus') {
          this.dialog.delete = true
        }
      },

      async fetchUser () {
        this.process.user = true
        
        let user_ids = this.form.users.map(item => item.id)

        user_ids.push(this.user.id)

        let params = {
          limit: 100000,

          search: this.autocomplete.user,

          'id[nin]': user_ids.join(',')
        }

        await get('admin/user', { params })
        .then(response => {
          let res = response.data

          this.process.user = false
          
          if (res.status === 200) {
            this.users = res.results.data
          }
        })
      },

      async fetchTemplate () {
        this.process.template = true

        let params = {
          limit: 100000,

          search: this.search_template,

          is_active_bool: true
        }

        this.templates.push({
          id: 0,
          title: 'Upload Dokumen',
          meta_json_object: {},
          color: this.set_color_rgb_soft
        })

        await get('files/data_template', { params })
        .then(response => {
          let res = response.data

          this.process.template = false

          if (res.status === 200) {
            let data = res.results.data

            data.forEach(item => {
              this.templates.push({
                id: item.id,
                title: item.title,
                meta_json_object: item.meta_json_object,
                color: '#f0f0f0'
              })
            })
          }
        })
      },

      async fetchUnit () {
        this.process.template = true

        let params = {
          limit: 100000
        }

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          this.process.template = false

          if (res.status === 200) {
            this.units = res.results.data
          }
        })
      },

      async fetchParent () {
        this.process.parent = true

        let params = {
          limit: 100000,

          type: 'FOLDER',

          'id[neq]': this.form.id
        }

        await get('files/data', { params })
        .then(response => {
          let res = response.data

          this.process.parent = false

          if (res.status === 200) {
            this.parents = res.results.data
          }
        })
      },

      async fetchShare (id) {
        this.process.share = true

        let params = {
          limit: 100000,

          doc_id: id
        }

        await get('files/data_share', { params })
        .then(response => {
          let res = response.data

          this.process.share = false

          if (res.status === 200) {
            this.shared = res.results.data

            this.shared.forEach(item => {
              this.form.users.push({
                id: item.user_id,
                is_can_download: item.is_can_download_bool,
                exp_datetime: item.exp_datetime !== '' && item.exp_datetime !== null ? moment(item.exp_datetime).format('YYYY-MM-DD') : null
              })
            })

            this.fetchUser()
          }
        })
      },

      async save_share () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('files/add_share', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false


            if (res.status === 200) {
              this.dialog.share = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('files/delete', {
          data: {
            id: this.form.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      toFiles (item) {
        this.selected.template_id = item.id

        this.form.title = item.title
        this.form.template_id = item.id
        this.form.template_meta_json_object = item.meta_json_object

        this.form.template_meta_json_object.tanggal = moment().format('YYYY-MM-DD')

        this.dialog.form = false
        this.dialog.from_template = true

        // this.fetchUnit()
      },

      async save_from_template () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'files/add_file' : 'files/update_file'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false


            if (res.status === 200) {
              this.dialog.from_template = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // this.exportToPDF()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      add_pegawai () {
        this.form.template_meta_json_object.kepada.push({
          nama: '',
          unit: ''
        })
      },

      async save_move () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('files/update_parent', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.move = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async generate_file (id) {
        this.message.error = ''

        let params = {
          id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}files/generate_file_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil generate dokumen'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      exportToPDF () {
        this.process.form = true

        if (this.selected.preview.template_id != 0) {
          let filename = `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`
  
          html2pdf(this.$refs.arsippdf, {
            margin: 0.2,
            filename: filename,
            image: { 
              type: 'jpeg', 
              quality: 0.98
            },
            html2canvas: { 
              dpi: 192, 
              letterRendering: true,
              useCORS: true
            },
            jsPDF: { 
              unit: 'in', 
              format: 'letter', 
              orientation: 'portrait'
            }
          })
  
          setTimeout(() => { 
            this.process.form = false
  
            this.dialog.pdf_preview = false
            this.selected.preview = {}
          }, 1000)
        } else {
          window.open(this.selected.preview.url, '_blank')
        }

        // var element = document.getElementById('arsippdf')

        // var opt = {
        //   // image:        { type: 'jpeg', quality: 0.98 },
        //   // html2canvas:  { scale: 3 },
        //   // jsPDF:        { unit: 'cm', format: 'letter', orientation: 'portrait' }

        //   margin: 0.2,
        //   filename: filename,
        //   image: { 
        //     type: 'jpeg', 
        //     quality: 0.98
        //   },
        //   html2canvas: { 
        //     dpi: 192, 
        //     letterRendering: true,
        //     useCORS: true
        //   },
        //   jsPDF: { 
        //     unit: 'in', 
        //     format: 'letter', 
        //     orientation: 'portrait'
        //   }
        // }

        // html2pdf().from(filename).set(opt).toPdf().output('datauristring').then(function (pdfAsString) {
        //   console.log(pdfAsString)
        //   // var arr = pdfAsString.split(',')
        //   // pdfAsString= arr[1]

        //   // var data = new FormData()
        //   // data.append("data" , pdfAsString)
        //   // var xhr = new XMLHttpRequest()
        //   // xhr.open('post', 'upload.php', true )
        //   // xhr.send(data)

          
        //   // const url = window.URL.createObjectURL(new Blob([pdfAsString], { type: 'application/pdf' }))
        //   // const link = document.createElement('a')
        //   // link.href = url
        //   // link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
        //   // document.body.appendChild(link)
        //   // link.click()

        //   const metadata = { type: 'application/pdf' }
        //   var blob = new Blob([pdfAsString], metadata)
        //   const file = new File([blob], 'amanata.pdf', metadata)

        //   console.log(blob, file)

        //   let formData = new FormData()
        //       formData.append('key', 'file')
        //       formData.append('file', file)

        //   fetch(`${process.env.VUE_APP_API_CDN}file.php`, {
        //     method: 'POST',
        //     body: formData
        //   })
        //   .then(res => res.json())
        //   .then(response => {
        //     console.log(response)
        //   })
        // })
      },

      async remove_shared (item) {
        this.process.delete_share = true

        await post(`files/delete_share`, {
          data: {
            id: item.id
          }
        })
        .then(response => {
          let res = response.data

          this.process.delete_share = false

          if (res.status === 200) {
            this.fetchShare(this.form.id)
          }
        })
      },

      download (url, filename) {
        fetch(url).then(function(t) {
          return t.blob().then((b)=>{
            var a = document.createElement("a")
            a.href = URL.createObjectURL(b)
            a.setAttribute("download", filename)
            a.click()
          })
        })
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }

  .from_html p {
    margin-bottom: 0px !important;
  }

  .from_html br {
    display: block !important;
    content: "";
    margin: 10px 0 !important;
  }

  .from_html ul, .from_html ol {
    padding-left: 16px !important;
  }
</style>